// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/ExtendedStatusMessage/ExtendedStatusMessage.less
// module id = 202
// module chunks = 2